"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isCheckboxDisabled = exports.getSnackbarMessage = void 0;
var _lodash = _interopRequireDefault(require("lodash.difference"));
var _constants = require("../../constants");
const getSnackbarMessage = ({
  lastUsedProductCodeInLists,
  selectedListIds,
  translations
}) => {
  const addedListIds = (0, _lodash.default)(selectedListIds, lastUsedProductCodeInLists);
  const removedListIds = (0, _lodash.default)(lastUsedProductCodeInLists, selectedListIds);
  if (addedListIds.length > 0 && removedListIds.length > 0) {
    return translations.listsWereUpdated;
  }
  if (addedListIds.length > 0) {
    return translations.productWasAddedToTheLists;
  }
  return translations.productWasRemovedFromTheLists;
};
exports.getSnackbarMessage = getSnackbarMessage;
const isCheckboxDisabled = ({
  list,
  productCode,
  selectedListIds
}) => !list.productCodes.includes(productCode) && !selectedListIds.includes(list.id) && list.productCodes.length >= _constants.MAX_PRODUCT_IN_LIST;
exports.isCheckboxDisabled = isCheckboxDisabled;
//# sourceMappingURL=utils.js.map